$(document).ready(function () {
    /**
     * TCR Module 
     */
    let results = {};
    let value, key;
    let objectStructure = null;
    let index = 0;
    function createObj(obj, boxes) {
        key = obj.closest('.box').find('h2').data('title');
        value = obj.text().replaceAll(" ", "_");
        if (objectStructure == null) {
            results[key] = value;
        } else if (boxes.hasClass('three')) {
            if (typeof results[key] === 'object') {
                results[key][index++] = value;
            } else {
                results[key] = {};
                results[key][index++] = value;
            }
            objectStructure = results
        } else {
            results[key] = value;
        }
        objectStructure = results;
        // console.log(objectStructure)

        funnelEventEmitter('surveyResults', objectStructure);
    }

    /**
     * Survey UI
     */
    $('.answer').on('click', function () {
        const boxes = $('.boxes');
        
        if (enableTCRModule == true) {
            createObj($(this), boxes);
        }
    });
    
    function pagination() {
        const boxes = $('.boxes');

        $('#nextStep').addClass('hidden');

        $('.answer').on('click', function () {
            // console.log($(this));

            let proceedBtn = $(this).closest('.box').find('.footer [data-proceed-step]');

            // console.log($(this).closest('.box').find('.footer [data-proceed-step]'));

            if ($(this).closest('.answers').attr('data-answer') == 'checkbox') {
                $(this).parent().toggleClass('checked');
                proceedBtn.removeClass('hidden').addClass('show');
            } else {
                $('.answers li').removeClass('checked');
                $(this).parent().addClass('checked');
            }

            if ($(this).closest('.answers').attr('data-answer') == 'radio') {
                if (boxes.hasClass('one')) {
                    boxes.removeClass('one').addClass('two');

                } else if (boxes.hasClass('two') && !boxes.hasClass('boxes--2Sections')) {
                    boxes.removeClass('two').addClass('three');
                }
            }
        });

        $('[data-proceed-step]').on('click', function () {
            if (boxes.hasClass('one')) {
                boxes.removeClass('one').addClass('two');

            } else if (boxes.hasClass('two')) {
                boxes.removeClass('two').addClass('three');
            }

            $('[data-proceed-step]').removeClass('show').addClass('hidden');
        })

        if (boxes.hasClass('boxes--2Sections')) {
            $('.box.two .answer').on('click', function () {
                $('#nextStep').removeClass('hidden').addClass('show');
                $('.boxes.two .box').addClass('clicked');
                // $('.skip').addClass('clicked');
            })

        } else {
            $('.box.three .answer').on('click', function () {
                $('#nextStep').removeClass('hidden').addClass('show');
                $('.boxes.three .box').addClass('clicked');
                // $('.skip').addClass('clicked');
            })
        }
    }

    if (!$('body').hasClass('surveyPage--desktop') || $(window).width() <= 1024) {
        pagination();
    } else if($('body').hasClass('surveyPage--desktop') || $(window).width() > 1025) {
        $('#nextStep').addClass('invisible');
    }

    $('.answers__item').on('click', function () {
        $('#nextStep').removeClass('invisible');
    })

    /**
     * Queue popup with delay redirection
     * Forward params to product page for 'Personalized Content From Survey' Component
    */
    //TODO: check YT - When 1st question has no param
    $('a[data-param]').on('click', function(e) {
        e.preventDefault();

        let url = $(this).attr('href');
        const checkedAnswers = $('.answers__item input:checked');

        let paramsToForward;
        
        let paramsConcat = '';
        
        $(checkedAnswers).each(function(item, index){
            paramsToForward = $(checkedAnswers[item]).data('param-fw');
            const thisParamValue = $(checkedAnswers[item]).attr('id').toLocaleLowerCase();
           
            if (paramsToForward == true) {
                paramsConcat += thisParamValue + '_';
            }
        });
        
        // console.log(paramsToForward && url.length && url.includes('?'));

        /**
         * manipulate array to remove last array item '_'
         */
        let paramsConcatOnly = paramsConcat.slice(0, -1);

        // console.log('paramsConcatOnly', paramsConcatOnly);

        if (paramsToForward && url.length && url.includes('?')) {
            url = url + `&fw_survey=${paramsConcatOnly}`;

        } else if (paramsToForward && url.length && !url.includes('?')) {
            url = url + `?fw_survey=${paramsConcatOnly}`;            
        }        

        if($('#queueModal').length) {
            setTimeout(function () {
                window.location.href = url;
            }, 5000);
        } else {
            window.location.href = url;
        }
    });
});